import Card from "@particles/card/Card";
import { CardVariations, TemplateProps } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

/**
 * This is the template B of cards. Used to display 3 cards in a row.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=12726-24205&t=V25hgDk5WxpFYhUc-4
 */
const TemplateC = ({
  className,
  cardProps,
}: TemplateProps): React.ReactElement => {
  return (
    <div
      data-testid="card-template-component"
      data-template="template-c"
      className={className}
    >
      {cardProps.map((props) => {
        const cardVariations: CardVariations = {
          content: {
            width: cn(
              "lg:w-1/2 w-full h-auto",
              props.variations?.content?.width
            ),
            extraClass: cn(
              "flex flex-col justify-center items-center text-center text-gray-125 font-lucida p-6 lg:p-0 text-balance",
              props.variations?.content?.extraClass
            ),
            blurb: {
              extraClass: cn(
                "text-gray-325 max-lg:block font-lucida font-medium text-base -tracking-5 leading-150 !line-clamp-5",
                props.variations?.content?.blurb?.extraClass
              ),
              wrapperClassName: cn(
                "w-full lg:w-2/3",
                props.variations?.content?.blurb?.wrapperClassName
              ),
            },
          },
          title: {
            size: cn(
              "text-6xl xl:w-2/3 xl:text-8xl",
              props.variations?.title?.size
            ),
            color: cn("text-gray-250", props.variations?.title?.color),
            extraClass: cn(
              "font-lct font-normal -tracking-2 mb-2",
              props.variations?.title?.extraClass
            ),
          },
          image: {
            position: props.variations?.image?.position ?? "left",
            width: cn("lg:w-1/2 w-full", props.variations?.image?.width),
            extraClass: cn(props.variations?.image?.extraClass),
            imageClassName: cn(
              "object-cover",
              props.variations?.image?.imageClassName
            ),
            aspectRatio: cn(
              props.variations?.image?.aspectRatio || "aspect-3x2"
            ),
            orientation: props.variations?.image?.orientation || "landscape",
          },
          kicker: {
            color: cn("text-blue-180", props.variations?.kicker?.color),
            extraClass: cn(
              "text-base font-normal font-freightSansPro mb-2",
              props.variations?.kicker?.extraClass
            ),
          },
        };

        return (
          <Card
            key={props.link + props.title}
            {...props}
            variations={cardVariations}
            className="flex w-full items-center justify-center"
          />
        );
      })}
    </div>
  );
};

export default TemplateC;
